package com.arena_web.core.viewmodel

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.remember
import com.arena_web.core.logger.getLogger
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.cancel

abstract class BaseViewModel {
    protected val logger = getLogger<BaseViewModel>()

    protected val viewModelScope = CoroutineScope(SupervisorJob() + Dispatchers.Main)

    open fun onCreate() {
        logger.debug("${this::class.simpleName} created")
    }

    open fun onDispose() {
        logger.debug("${this::class.simpleName} disposed")
        viewModelScope.cancel()
    }
}

@Composable
inline fun <reified T : BaseViewModel> rememberViewModel(
    key: Any? = null,
    crossinline factory: () -> T
): T {
    val viewModel = remember(key) {
        val vm = factory()
        vm.onCreate()
        vm
    }

    DisposableEffect(viewModel) {
        onDispose {
            viewModel.onDispose()
        }
    }

    return viewModel
}
